import { Upload, Button } from "antd";
import { CheckCircleFilled, CheckCircleOutlined, CheckCircleTwoTone, CheckOutlined, DeleteOutlined, DeleteTwoTone, UploadOutlined } from "@ant-design/icons";
import { Col } from "reactstrap";
import toast from "react-hot-toast";
import "../../utils/uploadedDoc.css"
import FormatFileSize from "../../../../../common/format/file";

const UploadDocument = ({
  label,
  accept = ".pdf",
  colSize = 4,
  maxSizeMB = 5,
  value,
  onChange,
}) => {

  const beforeUpload = (file) => {
    const isValidSize = file.size / 1024 / 1024 < maxSizeMB;

    if (!isValidSize) {
      toast.error(`Fichier trop volumineux (max ${maxSizeMB}MB)`);
      return Upload.LIST_IGNORE;
    }

    onChange?.(file);
    return false;
  };

  const handleRemove = () => {
    onChange?.(null);
  };

  const fileList = value
    ? [
        {
          uid: value.uid || "-1",
          name: value.name,
          status: "done",
        },
      ]
    : [];

  return (
    <Col lg={colSize}>
      <div className="upload-box">
        <p className="upload-title mt-2">{label}</p>

        {!value ? (
          <Upload.Dragger
            accept={accept}
            beforeUpload={beforeUpload}
            fileList={fileList}
            showUploadList={false}
          >
            <div className="upload-content">
              <UploadOutlined className="upload-icon" />
              <p className="upload-size">
                Glisser déposer votre fichier
              </p>
              <p className="upload-format">
                Format requis : {accept}
              </p>
              <p>OU</p>
              <Button className="upload-button">
                Importer
              </Button>
              <p className="upload-size mt-2">
                Taille maximum : {maxSizeMB}MB
              </p>
            </div>
          </Upload.Dragger>
        ) : (
            <div className="uploaded-content dashed-border-doc">
                <CheckCircleTwoTone twoToneColor="green"  className="upload-icon" />
                <p className="upload-size">Document uploadé</p>
                <p className="uploaded-doc-name mb-2">{value.name}</p>
                <Button danger size="small mb-2" onClick={handleRemove}>
                    <DeleteOutlined title={`Supprimer le fichier ${value.name}`}/>
                </Button>
                <p className="upload-size">
                    Taille : {FormatFileSize(value.size)}
                </p>
            </div>
        )}
      </div>
    </Col>
  );
};

export default UploadDocument;